export default __webpack_public_path__ + "static/sd-ec9ae12f32ee50ae57a0189d2b8214a8.svg";